module.exports = __webpack_public_path__ + "img/jigou.413b1dbf.png";